// import { toast } from 'react-toastify'

import { BASE_URL } from '../../api/endpoints'
import { FormData } from './policy'
import * as XLSX from 'xlsx'

export const checkValidation = (formData: FormData) => {
  if (
    formData?.otherInformation.relatedPolicyDocuments == '' ||
    formData?.otherInformation.owner == '' ||
    formData?.title == '' ||
    formData?.description == '' ||
    formData?.policyDocument == '' ||
    formData?.otherInformation.version == '' ||
    formData?.otherInformation.createdDate == '' ||
    formData?.otherInformation.createdApproval == '' ||
    formData?.otherInformation.approvedBy == '' ||
    formData?.otherInformation.approvedDate == '' ||
    formData?.otherInformation.commenceDate == '' ||
    formData?.otherInformation.nextReviewDate == ''
  ) {
    return true
  } else {
    return false
  }
}

export const calculatePageCount = (dataLength: number): number => {
  if (dataLength < 4) {
    return 1
  } else {
    return Math.ceil(dataLength / 4)
  }
}

export const lastStr = (str: string | undefined): string | undefined => {
  if (!str) return undefined // Handle undefined input
  const lastIndex = str.lastIndexOf('-')
  if (lastIndex === -1) return str // Return the original string if '-' is not found
  const lastString = str.substring(lastIndex + 1)
  return lastString
}

// Function to get the first letter of a string
export const getFirstLetter = (str: string): string | undefined => {
  if (str) return str.charAt(0)
}

// Function to download text file
export const handleDownloadTxt = (data: unknown[] | undefined) => {
  const jsonString = JSON.stringify(data)
  const blob = new Blob([jsonString], { type: 'text/plain' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = 'data.txt'
  anchor.click()
  URL.revokeObjectURL(url)
}

export const handleDownloadHtml = (htmlContent: string) => {
  const blob = new Blob([htmlContent], { type: 'text/html' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = 'data.html'
  anchor.click()
  URL.revokeObjectURL(url)
}

export const exportToExcel = (
  jsonData: unknown[] | undefined,
  fileName: string,
  fileType: string
) => {
  if (jsonData) {
    if (fileType == 'Excel2007') {
      const worksheet = XLSX.utils.json_to_sheet(jsonData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
      XLSX.writeFile(workbook, fileName + '.xlsx')
    }
    if (fileType == 'Excel95') {
      const worksheet = XLSX.utils.json_to_sheet(jsonData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
      XLSX.writeFile(workbook, fileName + '.xls', { bookType: 'xls' })
    }
  }
}

// Define a type for the structure of the expected response
interface FileResponse {
  data: {
    url: string;
  };
}

// export function downloadPDF(pdfUrl: string, fileName: string) {
//   fetch(pdfUrl)
//     .then((response) => {
//       if (!response.ok) {
//         throw new Error(
//           `Failed to fetch PDF: ${response.status} ${response.statusText}`
//         )
//       }
//       // Check if the server is forcing inline display
//       const contentDisposition = response.headers.get('Content-Disposition')
//       if (contentDisposition && contentDisposition.indexOf('inline') !== -1) {
//         throw new Error('Server is forcing inline display of PDF')
//       }
//       return response.blob()
//     })
//     .then((blob) => {
//       // Ensure the blob is treated as a PDF
//       const pdfBlob = new Blob([blob], { type: 'application/pdf' })
//       const url = window.URL.createObjectURL(pdfBlob)
//       const link = document.createElement('a')
//       link.href = url
//       link.setAttribute('download', fileName)
//       link.setAttribute('target', '_blank') // Open in a new tab if download fails
//       document.body.appendChild(link)
//       link.click()
//       document.body.removeChild(link)
//       // Clean up the URL object
//       window.URL.revokeObjectURL(url)
//     })
//     .catch((error) => {
//       console.error('Error downloading PDF:', error)
//       // toast.error(`Error downloading PDF: ${error.message}`)
//       // If download fails, try opening the PDF in a new tab
//       window.open(pdfUrl, '_blank')
//     })
// }
async function getFile(url: string): Promise<Response> {
  const token=sessionStorage.getItem('authToken')||''
  return fetch(`${BASE_URL}/files?url=${url}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

export async function  downloadPDF(pdfUrl: string, fileName: string) {
  try {
    const filename = pdfUrl.substring(
      pdfUrl.lastIndexOf('user_document/') + 'user_document/'.length
    )
    const response = await getFile(pdfUrl)
    console.log('responsetest',response)
    const result: FileResponse = await response.json();

    const link = document.createElement('a');
    link.href = result.data.url;
    console.log('responseurl',result.data.url)
    link.setAttribute('download', filename); // Add download attribute with fileName
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Handle response
  } catch (error) {
    console.log('fileName',fileName)
    console.error('Error downloading file:', error)
  }

  
  // // Extract the file name from the URL
  // console.log('fileName',fileName)
  // const token=sessionStorage.getItem('authToken')
  
  // token&&fetch(`${BASE_URL}/files?url=${pdfUrl}`, {
  //   headers: {
  //     'Authorization': `Bearer ${token}`, // Ensure the token is stored in localStorage
  //     'Content-Type': 'application/json'
  //   }
  // })
  // .then((response) => {
  //   if (!response.ok) {
  //     throw new Error('Network response was not ok');
  //   }
  //   return response.json();
    
  // }).then(result=>{const link = document.createElement('a');
  //   link.href = result.data.url;
  //   link.setAttribute('download', filename); // Add download attribute with fileName
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);})

  // .catch((error) => {
  //   console.error('Error downloading PDF:', error);
  // });
  // console.log(fileName)
  // const filename = pdfUrl.substring(
  //   pdfUrl.lastIndexOf('user_document/') + 'user_document/'.length
  // )

  // fetch(pdfUrl)
  //   .then((response) => {
  //     if (!response.ok) {
  //       throw new Error(
  //         `Failed to fetch PDF: ${response.status} ${response.statusText}`
  //       )
  //     }
  //     // Check if the server is forcing inline display
  //     const contentDisposition = response.headers.get('Content-Disposition')
  //     if (contentDisposition && contentDisposition.indexOf('inline') !== -1) {
  //       throw new Error('Server is forcing inline display of PDF')
  //     }
  //     return response.blob()
  //   })
  //   .then((blob) => {
  //     // Ensure the blob is treated as a PDF
  //     const pdfBlob = new Blob([blob], { type: 'application/pdf' })
  //     const url = window.URL.createObjectURL(pdfBlob)
  //     const link = document.createElement('a')
  //     link.href = url
  //     link.setAttribute('download', filename) // Use the extracted file name
  //     link.setAttribute('target', '_blank') // Open in a new tab if download fails
  //     document.body.appendChild(link)
  //     link.click()
  //     document.body.removeChild(link)
  //     // Clean up the URL object
  //     window.URL.revokeObjectURL(url)
  //   })
  //   .catch((error) => {
  //     console.error('Error downloading PDF:', error)
  //     // toast.error(`Error downloading PDF: ${error.message}`)
  //     // If download fails, try opening the PDF in a new tab
  //     window.open(pdfUrl, '_blank')
  //   })
}

export const initialData = {
  title: '',
  description: '',
  policyDocument: '',
  otherInformation: {
    relatedPolicyDocuments: '',
    owner: '',
    version: '',
    createdDate: '',
    createdApproval: '',
    approvedBy: '',
    approvedDate: '',
    commenceDate: '',
    // lastReviewDate: '',
    nextReviewDate: '',
  },
}

export const statusBgColor = (status: string): string => {
  switch (status) {
    case 'publish':
      return 'lightGreen'
    case 'active':
      return 'lightGreen'
    case 'unpublish':
      return 'palePink'
    case 'Lapsed':
      return 'paleYellow'
    case 'not active':
      return 'palePink'
    default:
      return 'gray3'
  }
}
